import { Box, Text, Link, VStack } from '@chakra-ui/react';

const AdminNavbar = () => {
  return (
    <Box
      position="fixed"
      left={0}
      top={0}
      height="25vh"
      width="12vh"
      bg="gray.200"
      boxShadow="md"
      p={4}
      zIndex="2"
      mt={16}
      transition="background-color 0.3s ease" 
      _hover={{ bg: "gray.300" }} 
      dir="ltr"
    >
      <Text fontSize="l" fontWeight="bold" mb={3}>
        Admin Panel
      </Text>
      <VStack align="flex-start" spacing={2}>
        <Link href="/admin" color="teal.600" _hover={{ textDecoration: 'underline' }}>
          Main
        </Link>
        <Link href="/admin/videos" color="teal.600" _hover={{ textDecoration: 'underline' }}>
          Videos
        </Link>
        <Link href="/admin/teachers" color="teal.600" _hover={{ textDecoration: 'underline' }}>
          Teachers
        </Link>
        <Link href="/admin/home" color="teal.600" _hover={{ textDecoration: 'underline' }}>
          Homepage
        </Link>
      </VStack>
    </Box>
  );
};

export default AdminNavbar;
